const META_ATTRIBUTION_MAX_STRING_LENGTH = 500;

const isBrowser = () => typeof window !== "undefined";

const isMetaPixelEnabled = () => {
  return isBrowser() && window.__instantTranscriberMarketingConsent !== false;
};

const cleanMetaValue = (value) => {
  if (value == null) return undefined;
  const normalized = String(value).slice(0, META_ATTRIBUTION_MAX_STRING_LENGTH);
  return normalized || undefined;
};

const readCookie = (name) => {
  if (!isBrowser() || !name) return undefined;
  const prefix = `${name}=`;
  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!cookie) return undefined;
  try {
    return decodeURIComponent(cookie.slice(prefix.length));
  } catch {
    return cookie.slice(prefix.length);
  }
};

const getUrlParam = (name) => {
  if (!isBrowser()) return undefined;
  try {
    return new URLSearchParams(window.location.search).get(name) || undefined;
  } catch {
    return undefined;
  }
};

const fbcFromFbclid = (fbclid) => {
  if (!fbclid) return undefined;
  return `fb.1.${Date.now()}.${fbclid}`;
};

export const getMetaAttributionParams = () => {
  if (!isMetaPixelEnabled()) return {};

  const fbclid = getUrlParam("fbclid");
  const params = {
    meta_fbclid: fbclid,
    meta_fbc: readCookie("_fbc") || fbcFromFbclid(fbclid),
    meta_fbp: readCookie("_fbp"),
  };

  return Object.fromEntries(
    Object.entries(params)
      .map(([key, value]) => [key, cleanMetaValue(value)])
      .filter(([, value]) => value !== undefined),
  );
};

export const appendMetaAttributionParams = (url) => {
  const nextUrl = url instanceof URL ? url : new URL(url);
  const params = getMetaAttributionParams();

  Object.entries(params).forEach(([key, value]) => {
    nextUrl.searchParams.set(key, value);
  });

  return nextUrl;
};
